import { forwardRef, type Ref, type SVGProps } from "react";
const IconNoPetsOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fillRule="evenodd"
      d="M3.877 2.458a1.057 1.057 0 0 1 1.443.1l2.86 3.143c.131-.58.362-1.138.686-1.646a3.35 3.35 0 0 1 2.561-1.561 3.37 3.37 0 0 1 2.712 1.28 5.17 5.17 0 0 1 1.12 3.003 5.1 5.1 0 0 1-.8 3.112c-.321.54-.784.97-1.327 1.251l1.369 1.505a6.91 6.91 0 0 1 7.503 3.277l2.361 4.383a5.7 5.7 0 0 1 .585 3.82l3.662 4.023a.947.947 0 0 1-.096 1.38 1.06 1.06 0 0 1-1.372-.03L3.852 3.907a1 1 0 0 0-.076-.076.947.947 0 0 1 .1-1.374m6.368 5.51L11.62 9.48a1 1 0 0 0 .176.017 1.39 1.39 0 0 0 1.001-.68c.349-.563.51-1.221.46-1.881a3.14 3.14 0 0 0-.65-1.831 1.44 1.44 0 0 0-1.02-.61h-.05a1.4 1.4 0 0 0-1.001.67 3.15 3.15 0 0 0-.46 1.89c.014.323.074.631.168.913m5.939 6.526 6.552 7.2a4 4 0 0 0-.212-.458l-2.341-4.363a4.83 4.83 0 0 0-4-2.38"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="m6.916 10.243.595.654c.324.436.587.954.764 1.533a4.67 4.67 0 0 1 0 2.842 2.89 2.89 0 0 1-1.861 1.941 2.4 2.4 0 0 1-.74.09 3 3 0 0 1-1.862-.68 4.67 4.67 0 0 1-1.59-2.362 4.7 4.7 0 0 1 0-2.851 2.91 2.91 0 0 1 1.84-1.912c.984-.302 2.025.008 2.854.745M4.823 11.36a.5.5 0 0 0-.17 0 1 1 0 0 0-.55.66 2.65 2.65 0 0 0 0 1.62c.146.545.457 1.031.89 1.392a1 1 0 0 0 .82.24 1 1 0 0 0 .551-.66 2.64 2.64 0 0 0 0-1.621c-.31-1.001-1.02-1.631-1.541-1.631"
      clipRule="evenodd"
    />
    <path d="m10.958 14.684 1.372 1.507a5 5 0 0 0-.503.712l-2.331 4.353a3.68 3.68 0 0 0 .5 4.252 2.75 2.75 0 0 0 3.172.73l.21-.08c1.668-.7 3.546-.7 5.214 0l.19.08c.84.375 1.791.299 2.548-.158l1.409 1.547A4.81 4.81 0 0 1 18 28.12l-.2-.09a4.68 4.68 0 0 0-3.602 0l-.21.09a4.9 4.9 0 0 1-1.902.39 4.9 4.9 0 0 1-3.582-1.61 5.71 5.71 0 0 1-.82-6.595l2.361-4.383q.387-.674.912-1.238" />
    <path
      fillRule="evenodd"
      d="M25.566 17.183c.245.08.502.121.76.12.68-.01 1.336-.25 1.862-.68a4.67 4.67 0 0 0 1.59-2.362 4.7 4.7 0 0 0 0-2.851 2.762 2.762 0 0 0-4.492-1.381 4.75 4.75 0 0 0-1.581 2.371 4.67 4.67 0 0 0 0 2.842 2.89 2.89 0 0 0 1.861 1.941m.96-5.563a1.2 1.2 0 0 1 .651-.26q.088 0 .17.03a1 1 0 0 1 .55.65c.17.53.17 1.1 0 1.63a2.73 2.73 0 0 1-.89 1.362 1 1 0 0 1-.82.24 1 1 0 0 1-.551-.66 2.65 2.65 0 0 1 0-1.621c.15-.537.461-1.016.89-1.371"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M20.253 11.5h-.16c-2.002-.11-3.483-2.202-3.352-4.673.13-2.472 1.76-4.333 3.682-4.333h.16c2.001.11 3.482 2.211 3.352 4.683S22.174 11.5 20.253 11.5m.16-7.005c-.84 0-1.601 1.07-1.671 2.392-.08 1.34.59 2.511 1.46 2.561h.05c.851 0 1.612-1.08 1.682-2.391s-.6-2.502-1.461-2.562z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconNoPetsOutlineSVG);
ForwardRef.displayName = "IconNoPetsOutline";
export { ForwardRef as IconNoPetsOutline };
